import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { translate } from 'services/i18nService';
import PaymentStore from 'stores/PaymentStore';
import Button from 'components/Button/Button';
import TokensIcon from 'shared/icons/Tokens';

import styles from './BalanceInfoMobile.css';


const BalanceInfoMobile = (props) => {
  const {
    onClick,
    areTokensNeeded,
    className,
    id,
  } = props;
  const { balance } = PaymentStore;

  const containerClasses = classnames(styles.balanceInfoContainer, className);
  const displayStatus = useMemo(() => {
    if (!areTokensNeeded) {
      return null;
    }

    return (
      <div className={styles.balanceStatus}>
        {translate('v2profile.you.need.more.tokens',
          { 0: '<b>', 1: '</b>' }
        )}
        {'.'}
      </div>
    );
  }, [areTokensNeeded]);

  return (
    <div className={containerClasses}>
      {displayStatus}

      <div className={styles.balanceInfo}>
        {translate('v2profile.balance')}
        {': '}
        <div className={styles.tokensIconContainer}>
          <TokensIcon className={styles.tokensIcon} />
        </div>
        {balance}
      </div>

      <div className={styles.buyTokensButton}>
        <Button
          colour="green"
          id={id}
          label={translate('v2profile.buy.tokens')}
          onClick={onClick}
        />
      </div>
    </div>
  );
};

BalanceInfoMobile.propTypes = {
  onClick: PropTypes.func.isRequired,
  areTokensNeeded: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
};


BalanceInfoMobile.defaultProps = {
  areTokensNeeded: false,
  className: undefined,
  id: undefined,
};

export default BalanceInfoMobile;
